import classes from "./SiderContentC.module.css";
import { Menu, message } from "antd";
import {
  FaSignOutAlt,
  FaFileInvoice,
  FaReceipt,
  FaHandsHelping,
  FaMoneyCheckAlt,
} from "react-icons/fa";
import signInSignUpLogo from "../../../assets/signInSignUp.png";
import { MdDashboard } from "react-icons/md";
import { NavLink } from "react-router-dom";
import { Link } from "react-router-dom";
import axios from "axios";
import { GiSellCard } from "react-icons/gi";
import { GiBuyCard } from "react-icons/gi";
import { AiOutlineDownSquare } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { MdWatchLater, MdAssignmentTurnedIn } from "react-icons/md";
import { BsFillGrid3X3GapFill, BsFillPeopleFill } from "react-icons/bs";
import { AiFillFileMarkdown, AiFillPropertySafety } from "react-icons/ai";
import { GiRuleBook } from "react-icons/gi";
import { AiTwotoneRest, AiOutlineTeam } from "react-icons/ai";

const { SubMenu } = Menu;

const SiderContentS = (props) => {
  const history = useNavigate();

  const handleLogout = (event) => {
    axios
      .get(props.url + "/api/v1/users/logout", {
        withCredentials: true,
      })
      .then((response) => {
        message.success({
          content: "Goodbye!!!! See You Again!!!",
          className: "custom-class",
          style: {
            marginTop: "20vh",
          },
        });
        history("/");
      })
      .catch((err) => {
        // console.log(err);
      });
  };

  return (
    <>
      <img
        className={classes["SignInSignUpLogo"]}
        src={signInSignUpLogo}
        alt="Logo"
      />
      <Menu
        mode="inline"
        defaultSelectedKeys={["empDashboard"]}
        // defaultOpenKeys={["misc"]}
        style={{
          height: "100%",
          borderRight: 0,
          overflowY: "auto",
        }}
        theme="light"
      >
        <Menu.Item key="empDashboard" icon={<MdDashboard />}>
          <Link to="/production/dashboard" style={{ textDecoration: "none" }}>
            Dashboard
          </Link>
        </Menu.Item>
        {/* <Menu.Item key="custInvoices" icon={<FaFileInvoice />}>
          <Link
            to="/sales/invoices-register"
            style={{ textDecoration: "none" }}
          >
            Invoices Register
          </Link>
        </Menu.Item>

        <Menu.Item key="custOrder" icon={<FaHandsHelping />}>
          <Link to="/sales/order-register" style={{ textDecoration: "none" }}>
            Order Register
          </Link>
        </Menu.Item>

        <Menu.Item key="custPendingSales" icon={<GiSellCard />}>
          <Link
            to="/sales/pending-sales-register"
            style={{ textDecoration: "none" }}
          >
            Pending Sales Register
          </Link>
        </Menu.Item>

        <Menu.Item key="custledger" icon={<FaReceipt />}>
          <Link to="/sales/ledger" style={{ textDecoration: "none" }}>
            Ledger
          </Link>
        </Menu.Item>

        <SubMenu key="Masters" title="Masters" icon={<AiTwotoneRest />}>
          <Menu.Item key="itemMaster">
            <Link
              to="/sales/itemMaster/item-details"
              style={{ textDecoration: "none" }}
            >
              Item Master
            </Link>
          </Menu.Item>
          <Menu.Item key="customerMaster">
            <Link
              to="/sales/customerMaster/customer-details"
              style={{ textDecoration: "none" }}
            >
              Customer Master
            </Link>
          </Menu.Item>
          {/* <Menu.Item key="categoryDetail">   
                    <NavLink to = '/sales/categoryDetail/category-Details'>
                        Category Detail
                    </NavLink>
                </Menu.Item> */}
        {/* <Menu.Item key="DealerMaster">
          <Link
            to="/sales/DealerMaster/dealer-details"
            style={{ textDecoration: "none" }}
          >
            Dealer Master
          </Link>
        </Menu.Item> */}
        {/* <Menu.Item key="chargedefMaster">   
                <NavLink to = '/sales/chargedefMaster/charge-details'>
                    Chargedef Master
                </NavLink>
            </Menu.Item> */}
        {/* <Menu.Item key="accountmaster">
          <Link
            to="/sales/accountmaster/account-details"
            style={{ textDecoration: "none" }}
          >
            Account Master
          </Link>
        </Menu.Item> */}
        {/* </SubMenu> */}

        {/* <SubMenu key="norms" title="Norms" icon={<GiRuleBook />}>
         
          <Menu.Item key="GaugeNorms">
            <Link
              to="/sales/norms/gauge-detail"
              style={{ textDecoration: "none" }}
            >
              Gauge Policy
            </Link>
          </Menu.Item>


          <Menu.Item key="itemWiseTax">
            <Link
              to="/sales/norms/tax-details"
              style={{ textDecoration: "none" }}
            >
              Item Wise Tax
            </Link>
          </Menu.Item>
        </SubMenu>  */}

        <SubMenu
          key="transactions"
          title="Transactions"
          icon={<MdAssignmentTurnedIn />}
        >
          <Menu.Item key="Salesformorder">
            <Link
              // to="/production/transaction/daily-prod"
              to="/production/transaction/daily-prod"
              style={{ textDecoration: "none" }}
            >
              Rolling Production
            </Link>
          </Menu.Item>

          <Menu.Item key="Salesform">
            <Link
              to="/production/transaction/furnance-detail"
              style={{ textDecoration: "none" }}
            >
              Furnance Production
            </Link>
          </Menu.Item>
          <Menu.Item key="requisition">
            <Link
              to="/production/transaction/breakdown-feeding"
              style={{ textDecoration: "none" }}
            >
              Breakdown Feeding
            </Link>
          </Menu.Item>
        </SubMenu>
        <SubMenu key="Reports" title="Reports" icon={<FaFileInvoice />}>
          <Menu.Item key="rolling-production-reports">
            <Link
              to="/production/rolling-production-register"
              style={{ textDecoration: "none" }}
            >
              Rolling Production Register
            </Link>
          </Menu.Item>
          <Menu.Item key="furnace-production-register">
            <Link
              to="/production/furnace_production-register"
              style={{ textDecoration: "none" }}
            >
              Furnace Production Register
            </Link>
          </Menu.Item>
          <Menu.Item key="breakdown-feeding-register">
            <Link
              to="/production/breakdownfeed-register"
              style={{ textDecoration: "none" }}
            >
              Breakdown Feeding Register
            </Link>
          </Menu.Item>
        </SubMenu>

        <Menu.Item
          key="empLogout"
          onClick={(event) => handleLogout(event)}
          icon={<FaSignOutAlt style={{ color: "red", opacity: "0.7" }} />}
        >
          <Link to="/" style={{ textDecoration: "none" }}>
            Logout
          </Link>
        </Menu.Item>
      </Menu>
    </>
  );
};

export default SiderContentS;
